'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.serializeAminoSignDoc = serializeAminoSignDoc;
exports.serializeDirectSignDoc = serializeDirectSignDoc;
var _signdoc = require('@cosmjs/amino/build/signdoc');
var _tx = require('cosmjs-types/cosmos/tx/v1beta1/tx');
function serializeDirectSignDoc(signDoc) {
	return _tx.SignDoc.encode(
		_tx.SignDoc.fromPartial({
			accountNumber: signDoc.accountNumber.toString(),
			authInfoBytes: signDoc.authInfoBytes,
			bodyBytes: signDoc.bodyBytes,
			chainId: signDoc.chainId
		})
	).finish();
}
function serializeAminoSignDoc(signDoc) {
	return (0, _signdoc.serializeSignDoc)(signDoc);
}
//# sourceMappingURL=serialize.js.map
